import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 16,
	viewBox: "0 0 11 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.06721 10.1L6.81236 16L11 16L3.16348 8L11 1.31174e-07L6.83195 8.14702e-08L1.06721 5.85L0.714564 6.21C0.256959 6.67861 1.03588e-07 7.31331 9.56972e-08 7.975C8.78066e-08 8.63669 0.256959 9.27139 0.714564 9.74L1.06721 10.1Z",
		fill: "currentColor"
	})
});
export default SvgArrowLeft;
